import { io } from "socket.io-client";
// const SOCKET_URL="ws://192.168.31.244:3000";
const SOCKET_URL="wss://twitter-louis.herokuapp.com"
const Socket = function(){
    this.socket;
};

Socket.prototype=Object.create(Object,{
    constructor: Socket,
    createConnect:{
        value:function(token){
            if (!token) return;
            const socket = io(SOCKET_URL, {
                auth: { token },
            });

            socket.on("connect", () => {
                console.log(`you connected width id:${socket.id}`);
            });

            this.socket=socket;
        }
    },
    emitChatMessage:{
        value: function (data){
            this.socket.emit("chat message", data);
        }
    },
    onChatMessage:{
        value:function(callback){
           console.log(this)
            this.socket.on('chat message',(message)=>{
                callback(message)
            })
        }
    },
    emitJoin:{
        value:function(roomId=1){
            
            this.socket.emit('join',{roomId})
        }
    },
    onJoin:{
        value: function (callback){
           
            this.socket.on('join', (data)=>{
                callback(data)
                console.log(data)
            })
        }
    },
    disconnect:{
        value:function(){
            this.socket.disconnect();
        }
    }
    
})
export const socket =new Socket()